const SET_ITEMS = (state, data) => {
  state.items = data
}

const SET = (state, payload) => {
  payload.key === 'name' ? state.item.name = payload.value : state.item.contentable[payload.key] = payload.value
}

const SET_ITEM = (state, data) => {
  state.item = data
}

const SET_TYPE = (state, type) => {
  state.item.contentable = {}
  state.item.contentable_type = type
}

const PUSH = (state, data) => {
  state.items.push(data)
}

const UPDATE = (state, data) => {
  state.item = data
}

const REMOVE = (state, id) => {
  state.items = state.items.filter(item => item.id !== id)
}

export default {
  SET,
  PUSH,
  UPDATE,
  REMOVE,
  SET_TYPE,
  SET_ITEM,
  SET_ITEMS
}
